import React from "react";
import Post from "../../components/post";
import Listings from "../../components/Listings";
import Cities from "../../components/Cities";
import "../../assets/styles/home.css";

const Home = () => {
  return (
    <div className="main-home">
      <Post />
      <Listings />
      <Cities />
    </div>
  );
};

export default Home;
